import arr from './projectsList';
import React from 'react';
import IndividualProject from './IndividualProject';

function Projects({ selectedCategory, setCategory }) {
  return (
    <>
      <div id="projectsSection" className="projects-div">
        <h1 className="projects-text">Projects</h1>
      </div>
      <div className={`${selectedCategory === 'spotify' ? '' : 'hide'}`}>
        <IndividualProject project={arr[0]} />
      </div>
      <div className={`${selectedCategory === 'amazon' ? '' : 'hide'}`}>
        <IndividualProject project={arr[1]} />
      </div>
      <div className={`${selectedCategory === 'other' ? '' : 'hide'}`}>
        <IndividualProject project={arr[2]} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          className={`${selectedCategory === 'spotify' ? 'btn active' : 'btn'}`}
          onClick={() => setCategory('spotify')}
        >
        </div>
        <div
          className={`${selectedCategory === 'amazon' ? 'btn active' : 'btn'}`}
          onClick={() => setCategory('amazon')}
        >
        </div>
        <div
          className={`${selectedCategory === 'other' ? 'btn active' : 'btn'}`}
          onClick={() => setCategory('other')}
        >
      </div>
    </div>
    </>
  )
}

export default Projects;